import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './AllServices.css';

const AllServices = () => {
    return (
        <>
            <Header />
            <div className="all-services">
                <div className="services-content">
                    {/* <h1>PHILIPPINE DENTAL ASSOCIATION</h1>
                    <h2>CAVITE CHAPTER</h2>
                    <h3>2024-2025</h3>
                    <h4>Elevating Dental Excellence through Competent Compassion</h4> */}

                    <table>
                        <thead>
                            <tr>
                                <th colSpan="4">STANDARDIZED FEES CHART APPROVED BY THE CAVITE DENTAL CHAPTER BOARD 2024 - 2025</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>CONSULTATION</td>
                                <td>P 500</td>
                                <td className="higlight">PEDIATRICS</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>DENTAL CERTIFICATE</td>
                                <td>P 500</td>
                                <td>SEALANTS</td>
                                <td>P 1,000</td>
                            </tr>
                            <tr>
                                <td>PERIAPICAL X-RAY</td>
                                <td>P 600 - P 800</td>
                                <td>EXTRACTION</td>
                                <td>P 1,000</td>
                            </tr>
                            <tr>
                                <td>EXTRA ANESTHESIA</td>
                                <td>P 300 - P 500</td>
                                <td>SS CROWN</td>
                                <td>P 4,000</td>
                            </tr>
                            <tr>
                                <td className="higlight">ORAL PROPHYLAXIS</td>
                                <td></td>
                                <td>SPACE MAINTAINER (UNI)</td>
                                <td>P 3,500</td>
                            </tr>
                            <tr>
                                <td>MILD</td>
                                <td>P 1000 - P 1,500</td>
                                <td>SPACE MAINTAINER (BILA)</td>
                                <td>P 8,000 - P 10,000</td>
                            </tr>
                            <tr>
                                <td>MODERATE</td>
                                <td>P 1,500 - P 2,000</td>
                                <td className="higlight">IMPLANTS</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>SEVERE</td>
                                <td>P 3,000</td>
                                <td>BONE AUGMENTATION</td>
                                <td>P 25,000 and up</td>
                            </tr>
                            <tr>
                                <td>DEEP SCALING (PER QUADRANT)</td>
                                <td>P 3,500 - P 4,000</td>
                                <td>DENTAL IMPLANT SCREW</td>
                                <td>P 45,000 UP</td>
                            </tr>
                            <tr>
                                <td className="higlight">FLUORIDE</td>
                                <td></td>
                                <td>DENTAL IMPLANT ABUTMENT</td>
                                <td>P 45,000 UP</td>
                            </tr>
                            <tr>
                                <td>FLUORIDE GEL</td>
                                <td>P 1,500 - P 2,000</td>
                                <td>DENTAL IMPLANT CROWN</td>
                                <td>P 15,000 UP</td>
                            </tr>
                            <tr>
                                <td>FLUORIDE VARNISH</td>
                                <td>P 1,500 - P 2,000</td>
                                <td>TOTAL (SCREW, ABUTMENT, CROWN)</td>
                                <td>P 105,000</td>
                            </tr>
                            <tr>
                                <td className="higlight">RESTORATIVE</td>
                                <td></td>
                                <td className="higlight">WHITENING</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>DIASTEMA CLOSURE</td>
                                <td>P 2,000 per side</td>
                                <td>IN-OFFICE TEETH WHITENING (U/L)</td>
                                <td>P 25,000</td>
                            </tr>
                            <tr>
                                <td>TEMPORARY DRESSING</td>
                                <td>P 800 - P 1,000</td>
                                <td>AT-HOME WHITENING (U/L)</td>
                                <td>P 15,000</td>
                            </tr>
                            <tr>
                                <td>COMPOSITE FILLING (PER SURFACE)</td>
                                <td>P 1000</td>
                                <td className="higlight">VENEERS</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>INLAY / ONLAY (COMPOSITE)</td>
                                <td>P 7,000 - P 8,000</td>
                                <td>DIRECT COMPOSITE</td>
                                <td>P 6,000</td>
                            </tr>
                            <tr>
                                <td className="higlight">EXTRACTION</td>
                                <td></td>
                                <td>INDIRECT COMPOSITE</td>
                                <td>P 10,000</td>
                            </tr>
                            <tr>
                                <td>SIMPLE EXTRACTION</td>
                                <td>P 1,000 - P 1,500</td>
                                <td>INDIRECT PORCELAIN</td>
                                <td>P 18,000 UP</td>
                            </tr>
                            <tr>
                                <td>COMPLICATED CASE</td>
                                <td>P 3,000</td>
                                <td>ENDODONTICS</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td className="higlight">CROWN AND BRIDGE</td>
                                <td></td>
                                <td>MONO ROOTED TOOTH (ANTERIOR)</td>
                                <td>P 9,000</td>
                            </tr>
                            <tr>
                                <td>ACRYLIC / PLASTIC</td>
                                <td>P 5,000</td>
                                <td>MULTI ROOTED (PER CANAL)</td>
                                <td>P 7,000 UP</td>
                            </tr>
                            <tr>
                                <td>PFM CROWN</td>
                                <td>P 8,500 - P 9,500</td>
                                <td>POST AND CORE BUILD-UP (FIBER POST)</td>
                                <td>P 5,000</td>
                            </tr>
                            <tr>
                                <td>PFM CROWN (TILITE)</td>
                                <td>P 12,000 and up</td>
                                <td className="higlight">COMPLETE DENTURE</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>ALL CERAMIC PORCELAIN</td>
                                <td>P 20,000 UP per pc</td>
                                <td>NEW ACE (U/L)</td>
                                <td>P 16,000 UP</td>
                            </tr>
                            <tr>
                                <td>ZIRCONIA CERAMIC CROWN</td>
                                <td>P 25,000 UP</td>
                                <td>NEW ACE FX</td>
                                <td>P 20,000</td>
                            </tr>
                            <tr>
                                <td className="higlight">ORTHODONTICS</td>
                                <td></td>
                                <td>NATURA TONE (U/L)</td>
                                <td>P 18,000 UP</td>
                            </tr>
                            <tr>
                                <td>METAL BRACKETS</td>
                                <td>P 50,000 UP</td>
                                <td>NEW ACE (US) (U/L)</td>
                                <td>P 24,000</td>
                            </tr>
                            <tr>
                                <td>CERAMIC BRACKETS</td>
                                <td>P 80,000 UP</td>
                                <td>BIOTONE (U/L)</td>
                                <td>P 26,000</td>
                            </tr>
                            <tr>
                                <td>SELF-LIGATING METAL BRACKETS</td>
                                <td>P 100,000 UP</td>
                                <td>BIOFORM (U/L)</td>
                                <td>P 26,000</td>
                            </tr>
                            <tr>
                                <td>SELF-LIGATING CERAMIC BRACKETS</td>
                                <td>P 120,000 UP</td>
                                <td>IVOCAP (U/L)</td>
                                <td>P 60,000</td>
                            </tr>
                            <tr>
                                <td>CLEAR ALIGNERS</td>
                                <td>P250,000-P300,000</td>
                                <td>THERMOSEHS (U/L)</td>
                                <td>P 60,000</td>
                            </tr>
                            <tr>
                                <td>FUNCTIONAL APPLIANCE</td>
                                <td>P 20,000 - P 25,000</td>
                                <td className="higlight">PARTIAL DENTURE</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>HAWLEY'S RETAINER (U/L)</td>
                                <td>P 12,000</td>
                                <td>STAYPLATE (2 PONTICS; + 500)</td>
                                <td>P 4,000 and up</td>
                            </tr>
                            <tr>
                                <td>ESSIX RETAINERS</td>
                                <td>P 14,000</td>
                                <td>ASSEMBLED CASTED CLASP</td>
                                <td>P 4,000 plus P 1,500 per casted clasp</td>
                            </tr>
                            <tr>
                                <td>FIXED RETAINERS</td>
                                <td>P 10,000 UP</td>
                                <td>FLEXIBLE UNI</td>
                                <td>P 15,000</td>
                            </tr>
                            <tr>
                                <td>TEMPORARY ANCHORAGE DEVICE</td>
                                <td>P 8,000</td>
                                <td>FLEXIBLE BILA</td>
                                <td>P 20,000 up</td>
                            </tr>
                            <tr>
                                <td>BRACKET RECEMENTATION</td>
                                <td>P 1000 - P 1,500</td>
                                <td>GOLDMESH (ADDITIONAL)</td>
                                <td>P 2,500 up</td>
                            </tr>
                            <tr>
                                <td>BRACKET REMOVAL</td>
                                <td>P 10,000 UP</td>
                                <td>LUCITONE (ADD IN)</td>
                                <td>P 2,500 up</td>
                            </tr>
                            <tr>
                                <td>DOWNPAYMENT</td>
                                <td>Minimum 30% - 50% of the total cost</td>
                                <td>ONE PIECE UNI</td>
                                <td>P 12,000</td>
                            </tr>
                            <tr>
                                <td className="higlight">SURGICAL PROCEDURES</td>
                                <td></td>
                                <td>ONE PIECE BILA</td>
                                <td>P 15,000 up</td>
                            </tr>
                            <tr>
                                <td>ODONTECTOMY</td>
                                <td>P 10,000 and up</td>
                                <td>FLEXI COMBI (BILATERAL)</td>
                                <td>P 30,000</td>
                            </tr>
                            <tr>
                                <td>APICOECTOMY</td>
                                <td>P10,000 - P15,000</td>
                                <td>RELINE (LABORATORY)</td>
                                <td>P 3,000 - P 4,000</td>
                            </tr>
                            <tr>
                                <td>FRENECTOMY</td>
                                <td>P10,000 - P15,000</td>
                                <td>REBASE (LABORATORY)</td>
                                <td>50% OF THE DENTURE COST</td>
                            </tr>
                            <tr>
                                <td>GINGIVECTOMY (PER ARCH)</td>
                                <td>P 15,000</td>
                                <td>CHAIRSIDE RELINE</td>
                                <td>P 1,500</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>RECEMENTATION OF CROWN</td>
                                <td>P 1,000 per unit</td>
                            </tr>
                            <tr>
                                <td className="higlight">*Senior Discount - 20% of Prof. Fee</td>
                                <td>[30% of Total Cost]</td>
                                <td>NIGHT GUARD (PER ARCH)</td>
                                <td>P 7,000</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* <div className="signatures">
                        <p>Dr. Réchelle Joson</p>
                        <p>Executive Secretary</p>
                        <p>Dr. Melúita O. Bayot</p>
                        <p>CDC President 2024-2025</p>
                        <p>Dr. Eleonor Mengullo</p>
                        <p>Executive Vice President</p>
                        <p>Dr. Rose Nolasco</p>
                        <p>VP District 1</p>
                        <p>Dr. Horner Godilano</p>
                        <p>VP District 2</p>
                        <p>Dr. Judy Marfel Gavenia</p>
                        <p>VP District 3</p>
                    </div> */}
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default AllServices;